import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { HttpHeaders, HttpParams, HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { SWAlertService } from '../../services/swalert.service';
import { Router } from '@angular/router';
import { TSFuntionService } from '../../services/ts-funtion.service';
import * as _ from 'lodash';
import Swal from 'sweetalert2';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/public_api';

@Component({
  selector: 'app-admin-glaccount',
  templateUrl: './admin-glaccount.component.html',
  styleUrls: ['./admin-glaccount.component.css']
})
export class AdminGlaccountComponent implements OnInit {
  get f() { return this.GLAccountForm.controls; }
  GLAccountForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private swal: SWAlertService,
    private router: Router,
    private System: TSFuntionService
  ) { }

  public settings_companyname = {};
  public settings_companyFilter = {};
  _DataCompanyName: any = [];
  _DataSelectGL: any = [];
  _DataType: any = [];
  _DataGLAccount: any = [];
  _DataAll: any = [];
  _DataSetCom: any = [];
  sGLName = "";
  IsAll: boolean = false;
  IsCheck: boolean = false;
  ArrCheckCom: any[] = [];
  ArrEdit: any[] = [];
  ArrDelete: any[] = [];
  noResult = false;
  IsCreate: boolean = false;
  IsEdit: boolean = false;
  IsDelete: boolean = false;
  sGLNo: string = null;
  ResultPermission: boolean = false;
  ResultPermissionMunu: boolean = false;
  IsViewMode: boolean = false;

  async ngOnInit() {
    this.System.BlockUI();
    this.GLAccountForm = this.formBuilder.group({
      sGLNo: ["", Validators.required],
      sGLAccount_Name: [""],
      COMPANY_NAME: ["", Validators.required],
      sTitle: ["", Validators.required],
      cActive: [1, Validators.required],
      IsDefault: [false]
    });
    this.settings_companyname = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.settings_companyFilter = {
      singleSelection: false,
      idField: 'COMPANY_CODE',
      textField: 'COMPANY_NAME',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    this.SetDataOnPageLoad();
    this.GetData();

    //Check Permission Menu
    let ObjData = {
      sRequestID: "",
      nMenuID: 15
    }
    this.ResultPermission = await this.System.CheckPermission(ObjData);
    if (this.ResultPermission) {
      //Check Permission Admin
      this.ResultPermissionMunu = await this.System.CheckPermissionMeun(15);
      if (!this.ResultPermissionMunu) {
        this.GLAccountForm.controls.sGLNo.disable();
        this.GLAccountForm.controls.sGLAccount_Name.disable();
        this.GLAccountForm.controls.sTitle.disable();
        this.GLAccountForm.controls.cActive.disable();
        this.GLAccountForm.controls.IsDefault.disable();

        this.IsViewMode = true;
      }
    }

    this.System.UnBlockUI();
  }

  //#region Set Data On Page Load
  SetDataOnPageLoad() {
    this.System.BlockUI();
    //AutocompleteGLAccount
    const httpOptions_GLAccount = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
    };
    this.http.get<any>(this.System.SiteName + "api/AdminGLAccount/_GetGLAccount", httpOptions_GLAccount).subscribe(res => {
      if (res) {
        this.System.UnBlockUI();
        this._DataGLAccount = res;
        this._DataGLAccount = res.map(m => ({
          sGLNo: m.GL_ACCOUNT_NO,
          GL_ACCOUNT_NO: m.GL_ACCOUNT_NO + " - " + m.sSHORT_TEXT,
          sSHORT_TEXT: m.sSHORT_TEXT
        }));
      }
    });

    //MultiSelectCompanyName
    const httpOptions_CompanyName = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    this.http.get<any>(this.System.SiteName + "api/AdminGLAccount/_GetCompanyName", httpOptions_CompanyName).subscribe(res => {
      if (res) {
        this.System.UnBlockUI();
        this._DataCompanyName = res;
      }
    });

    //DropDownSearchType
    const httpOptions_Type = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }), params: new HttpParams()
        .set('nMainID', '2')
    };
    this.http.get<any>(this.System.SiteName + "api/AdminGLAccount/_GetType", httpOptions_Type).subscribe(res => {
      if (res) {
        this.System.UnBlockUI();
        this._DataType = res;
      }
    });
  }
  //#endregion

  //#region Event GLAccount
  onOptionsSelected_GLAccount(event: TypeaheadMatch): void {

    let txtSearch = event.item['sGLNo'];
    let lstData = this._DataGLAccount.filter(NO => NO.sGLNo == txtSearch)[0]
    this.sGLNo = lstData.sGLNo;
    this.sGLName = lstData.GL_ACCOUNT_NO;
    this.GLAccountForm.patchValue({
      sGLNo: lstData.sGLNo
    });

    if (lstData != "") {
      //SelectGLAccount
      const httpOptions_SelectGLAccount = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }), params: new HttpParams()
          .set('GL_ACCOUNT_NO', lstData.sGLNo)
      };
      this.http.get<any>(this.System.SiteName + "api/AdminGLAccount/_GetSelectGL", httpOptions_SelectGLAccount).subscribe(res => {
        if (res) {
          this._DataSelectGL = res;
          this.GLAccountForm.patchValue({
            sGLAccount_Name: lstData.sSHORT_TEXT,
            COMPANY_NAME: this._DataSelectGL
          });
        }
      });
    } else {
      this.GLAccountForm.patchValue({
        sGLAccount_Name: "",
        COMPANY_NAME: "",
      });
    }
  }

  typeaheadNoResults_GLAccount(event: boolean): void { //เช็คว่า autocomplete มี value ?
    this.noResult = event; //true,false
  }

  typeaheadOnBlur_GLAccount(event: boolean): void { //เช็คว่า autocomplete มี value ?
    if (this.noResult == true) { //ไม่มีให้ blur
      this.GLAccountForm.patchValue({
        sGLNo: ""
      });
    }
  }
  //#endregion

  //#region Table
  FilterGrid = {
    sSearch: "",
    sType: "",
    COMPANY_CODE: [],
    cActive: "",
  }

  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      { sValue: 10 },
      { sValue: 20 },
      { sValue: 50 },
      { sValue: 100 }
    ]
  }
  IsHeaderSort = "";
  SortDirection = "";
  SortICO = "fas fa-sort";
  IcoSort = "fas fa-sort";
  IcoSortDesc = "fas fa-sort-up";
  IcoSortAsc = "fas fa-sort-down";
  sDetailData = "";

  _ArrData = [];
  _ArrDataBind = [];
  _ArrDataAll = [];
  //#endregion

  //#region Header Colomn
  @Output() onChange = new EventEmitter();
  Columns = [
    { ColumnName: "Type", SortField: "sTitle", Width: "10%" },
    { ColumnName: "GL Account", SortField: "sGLAccount", Width: "38%" },
    { ColumnName: "Company Authorize", SortField: "COMPANY", Width: "30%" },
    { ColumnName: "Status", SortField: "Status", Width: "10%" },
    { ColumnName: "", SortField: "", Width: "7%" },
  ]
  //#endregion

  //#region Sort Data
  //Event ตอนกด Click Header
  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      }
      else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(this._ArrData, [SortField], [this.SortDirection]);
      this.BindDataTable();
    }
  }

  PageSizeChange() {
    //setTimeout(() => , 1000);
    this.OptionGrid.nCurrentPage = 1
    this.BindDataTable();
  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }

  GetData() {
    this.System.BlockUI();
    //Condition Filter Type
    let _sType: string = this.FilterGrid.sType.length > 0 ? (this.FilterGrid.sType.toString() == "1" ? "GL" : "GL VAT") : "";
    let _sComCode: string = this.FilterGrid.COMPANY_CODE.length > 0 ? this.FilterGrid.COMPANY_CODE.map(e => e.COMPANY_CODE).join(",") : "";
    let _sStatus: string = this.FilterGrid.cActive.length > 0 ? (this.FilterGrid.cActive.toString() == "1" ? "Y" : "N") : "";
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set('sSearch', this.FilterGrid.sSearch)
        .set('sType', _sType)
        .set('COMPANY_CODE', _sComCode)
        .set('cActive', _sStatus)
    };
    this.http.get<any>(this.System.SiteName + "api/AdminGLAccount/ListData", httpOptions).subscribe(res => {
      if (res) {
        this.System.UnBlockUI();
        this._ArrDataAll = res.map(m => ({
          sTitle: m.sTitle,
          sGLNo: m.sGLNo,
          sGLAccount: m.sGLAccount,
          cActive: m.cActive,
          IsDefault: m.IsDefault,
          Status: m.Status,
          COMPANY: m.ArrCOMPANY.filter(f => f != null).join(",")
        }));
        this._ArrData = this._ArrDataAll;
      }
      else {
        this.System.UnBlockUI();
        this._ArrData = [];
      }
      this.BindDataTable();
    });
  }

  BindDataTable() {
    this.OptionGrid.nTotalItem = this._ArrData.length;

    let nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * this.OptionGrid.nPageSize;
    let nEndIndex_Take = this.OptionGrid.nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({}, val)));
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);

    let nStartItemPage = nStartIndex_Take + 1;
    let nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = "Showing " + nStartItemPage + " to " + nLastItemPage + " of " + this._ArrData.length + " entries";
  }
  //#endregion

  //#region Sweet Alert OnClick
  onClick(value: string) {
    let _this = this;
    switch (value) {
      case "Submit":
        if (this.GLAccountForm.invalid) {
          this.validateAllFormFields(this.GLAccountForm);
        } else {
          this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, this.swal.BoxMsg.Desc_Confirm_Submit, function () { _this.onSubmit() }, undefined)
        }
        break;
      case "Back":
        this.router.navigate(["/admin-menu"]);
        break;
      case "Reset":
        this.onReset()
        break;
      case "Delete":
        this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, this.swal.BoxMsg.Desc_Confirm_Delete, function () { _this.Delete() }, undefined)
        break;
      default:
    }
  }
  //#endregion

  //#region Validate
  isFieldValid(field: string) {
    return !this.GLAccountForm.get(field).valid && this.GLAccountForm.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      if (control instanceof FormControl) {             //{4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        //{5}
        this.validateAllFormFields(control);            //{6}
      }
    });
  }
  //#endregion

  //#region Change Default Enable
  ChangeDefault() {
    if (this.GLAccountForm.controls.sTitle.value == "6") {
      this.GLAccountForm.controls.IsDefault.enable(); //เปิดฟิลด์
    } else {
      this.GLAccountForm.controls.IsDefault.setValue(false); //Set ค่า
      this.GLAccountForm.controls.IsDefault.disable(); //ปิดฟิลด์
    }
  }
  //#endregion

  SetCompayny() {
    //this.GLAccountForm.get("COMPANY_NAME").markAsUntouched({ onlySelf: true });
    //this.GLAccountForm.controls["COMPANY_NAME"].setValue("");//Set ค่า
    //this.GLAccountForm.get("COMPANY_NAME").setValue(this._DataSetCom);

    //this._DataSetCom = [];
    //this._DataSetCom.push({
    //  COMPANY_CODE: "385",
    //  COMPANY_NAME: "BPS - บริษัท บิซิเนส โปรเฟสชั่นแนล โซลูชั่นส์ จำกัด"
    //})
    //this._DataSetCom.push({
    //  COMPANY_CODE: "81",
    //  COMPANY_NAME: "SSS - บริษัท สปอร์ต เซอร์วิสเซส อัลไลแอนซ์ จำกัด"
    //})

    this.GLAccountForm.patchValue({
      COMPANY_NAME: this._DataSetCom
    });
  }

  //#region Check All
  CheckAll() {
    if (this.IsAll) {
      this.IsDelete = true;
    } else {
      this.IsDelete = false;
    }
    this._ArrDataBind.forEach(f => f.IsDelete = this.IsAll);
  }
  //#endregion

  //#region Check Delete
  checkDel() {
    this.IsDelete = this._ArrDataBind.filter(f => f.IsDelete == true).length > 0 ? true : false;
  }
  //#endregion

  //#region Check Duplicate Data
  async CheckDuplicateData() {
    this.System.BlockUI();

    let COMPANY_NAME = this.GLAccountForm.controls.COMPANY_NAME.value; //get date
    let sGLNo = this.GLAccountForm.controls.sGLNo.value; //get date

    let Result = { IsPass: true, Msg: "" };

    //Case 1 เช็คจาก Database
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }), params: new HttpParams()
        .set('COMPANY_NAME', COMPANY_NAME)
        .set('sGLNo', sGLNo)
    };
    await this.http.get<any>(this.System.SiteName + "api/AdminGLAccount/CheckDuplicateData", httpOptions).toPromise().then(res => {
      if (res) {
        if (res.length > 0) {
          if (res[0].IsDelete) {
            this.System.UnBlockUI();
            Result.IsPass = true;
            this.sGLNo = res[0].sGLNo + "";
          } else if (this.IsEdit) {
            this.System.UnBlockUI();
            Result.IsPass = true;
            this.sGLNo = res[0].sGLNo + "";
          } else {
            this.System.UnBlockUI();
            Result.IsPass = false;
          }
        } else {
          this.System.UnBlockUI();
          Result.IsPass = true;
        }
      } else {
        this.System.UnBlockUI();
        Result.IsPass = false;
      }
    });
    return Result;
  }
  //#endregion

  //#region Save
  async onSubmit() {
    this.System.BlockUI();

    let _this = this;

    let Company = this.GLAccountForm.controls["COMPANY_NAME"].value; //get company

    if (this.GLAccountForm.invalid) {
      this.validateAllFormFields(this.GLAccountForm);
      return;
    } else {
      let result: any = await this.CheckDuplicateData();//check duplicate

      if (result.IsPass) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json'
          })
        };
        let _ObjData = {
          sGLNo: this.GLAccountForm.value["sGLNo"],
          sGLName: this.GLAccountForm.value["sGLAccount_Name"],
          COMPANY_NAME: Company,
          nDataID: this.GLAccountForm.value["sTitle"] + "",
          cActive: this.GLAccountForm.value["cActive"],
          IsDefault: this.GLAccountForm.controls.IsDefault.value,
          IsEdit: this.IsEdit
        }
        let ITEM = JSON.stringify(_ObjData);
        this.http.post<any>(this.System.SiteName + 'api/AdminGLAccount/Save', ITEM, httpOptions).toPromise().then(res => {
          this.System.UnBlockUI();
          if (res.Status == this.System.SysProcess.SessionExpired) {
            this.System.SessionExpire();
          }
          else if (res.Status == this.System.SysProcess.Success) {
            this.swal.SwAlert.Success(this.swal.BoxMsg.Title_Success, this.swal.BoxMsg.Desc_SaveComplete, function () {
              _this.GetData();
              _this._ArrData = [];
              _this._ArrDataAll.forEach(val => _this._ArrData.push(Object.assign({}, val)));
              _this.BindDataTable();
              _this.onReset();
            });
          }
          else {
            this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, res.Msg, function () { });
          }
        });
      } else {
        this.System.UnBlockUI();
        this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, this.swal.BoxMsg.Desc_Warning_Duplicate, function () { });
      }
    }
  }
  //#endregion

  //#region Edit
  async Edit(sGLNo: any) {
    this.System.BlockUI();
    let This = this;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }), params: new HttpParams()
        .set('sGLNo', sGLNo)
    };
    let res = await this.http.get(this.System.SiteName + 'api/AdminGLAccount/Edit', httpOptions).toPromise();

    if (res) {

      this._DataAll = res;
      this._DataSetCom = [];
      this._DataAll.forEach(f =>
        this._DataSetCom.push({
          COMPANY_CODE: f.COMPANY_CODE,
          COMPANY_NAME: f.COMPANY_NAME
        }));
      this.GLAccountForm.patchValue({
        sGLNo: res[0].sGLNo,
        sGLAccount_Name: res[0].sGLName,
        //COMPANY_NAME: null,
        sTitle: res[0].nDataID,
        cActive: res[0].cActive == "Y" ? 1 : 2,
        IsDefault: res[0].IsDefault
      });
      this.ChangeDefault();

      this.System.UnBlockUI();
    } else {
      this.GLAccountForm.patchValue({
        sGLNo: "",
        sGLAccount_Name: "",
        COMPANY_NAME: "",
        sTitle: "",
        cActive: "",
        IsDefault: false
      });
    }

    //this.System.UnBlockUI();

    document.getElementById('Top').scrollIntoView({ behavior: "smooth" }); //scroll to top
    document.getElementById('btnSetCom').click();
    this.IsEdit = true;
  }

  //this.SetCompayny();
  //#endregion

  //#region Delete
  Delete() {
    this.System.BlockUI();
    let _this = this;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    this._ArrDataBind.forEach(f =>
      this.ArrDelete.push({
        sGLNo: f.sGLNo,
        IsDelete: f.IsDelete
      }))
    let ITEM = JSON.stringify(this.ArrDelete);
    this.http.post<any>(this.System.SiteName + 'api/AdminGLAccount/Delete', ITEM, httpOptions).subscribe(res => {
      this.System.UnBlockUI();
      if (res.Status == this.System.SysProcess.Success) {
        this.swal.SwAlert.Success(this.swal.BoxMsg.Title_Success, this.swal.BoxMsg.Desc_Success_Delete, function () {
          _this.GetData();
          _this._ArrData = [];
          _this._ArrDataAll.forEach(val => _this._ArrData.push(Object.assign({}, val)));
          _this.BindDataTable();
          _this.onReset();
        });
        this.IsDelete = false;
      }
      else {
        this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, res.Msg, function () { Swal.close(); });
        this.IsDelete = false;
      }
    });
  }
  //#endregion

  //#region Reset
  onReset() {
    this.GLAccountForm.get("sGLNo").markAsUntouched({ onlySelf: true });
    this.GLAccountForm.get("sGLAccount_Name").markAsUntouched({ onlySelf: true });
    this.GLAccountForm.get("COMPANY_NAME").markAsUntouched({ onlySelf: true });
    this.GLAccountForm.get("sTitle").markAsUntouched({ onlySelf: true });
    this.GLAccountForm.get("cActive").markAsUntouched({ onlySelf: true });
    this.GLAccountForm.get("IsDefault").markAsUntouched({ onlySelf: true });

    this.GLAccountForm.controls["sGLNo"].setValue("");//Set ค่า
    this.GLAccountForm.controls["sGLAccount_Name"].setValue("");//Set ค่า
    this.GLAccountForm.controls["COMPANY_NAME"].setValue("");//Set ค่า
    this.GLAccountForm.controls["sTitle"].setValue("");//Set ค่า
    this.GLAccountForm.controls["cActive"].setValue(1);//Set ค่า
    this.GLAccountForm.controls["IsDefault"].setValue("");//Set ค่า

    this.GLAccountForm.controls["sGLNo"].setValidators(Validators.required);//กำหนด Validate
    this.GLAccountForm.controls["COMPANY_NAME"].setValidators(Validators.required);//กำหนด Validate
    this.GLAccountForm.controls["sTitle"].setValidators(Validators.required);//กำหนด Validate
    this.GLAccountForm.controls["cActive"].setValidators(Validators.required);//กำหนด Validate

    this.GLAccountForm.controls["sGLNo"].setErrors(null);//ปรับ Control ให้เป็นปกติ
    this.GLAccountForm.controls["sGLAccount_Name"].setErrors(null);//ปรับ Control ให้เป็นปกติ
    this.GLAccountForm.controls["COMPANY_NAME"].setErrors(null);//ปรับ Control ให้เป็นปกติ
    this.GLAccountForm.controls["sTitle"].setErrors(null);//ปรับ Control ให้เป็นปกติ
    this.GLAccountForm.controls["cActive"].setErrors(null);//ปรับ Control ให้เป็นปกติ
    this.GLAccountForm.controls["IsDefault"].setErrors(null);//ปรับ Control ให้เป็นปกติ

    this.GLAccountForm.controls["sGLNo"].updateValueAndValidity();//Update Validate
    this.GLAccountForm.controls["COMPANY_NAME"].updateValueAndValidity();//Update Validate
    this.GLAccountForm.controls["sTitle"].updateValueAndValidity();//Update Validate
    this.GLAccountForm.controls["cActive"].updateValueAndValidity();//Update Validate

    this.GLAccountForm.controls["IsDefault"].disable();//ปิดฟิลด์ IsDefault
  }
  //#endregion
}

